import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../screens/home";
import { Dex } from "../screens/dex";

export const RoutesConfig: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/buy" element={<Dex />} />
    </Routes>
  );
};
